export default "__VITE_ASSET__heKvXdLy__"